// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__jhVrr","content":"Consent_content__3X5Xy","footer":"Consent_footer__1FQsk"};